import React, { useState } from "react";
import { Button, Steps } from "antd";
import { MembersPortalLivePerformanceValidator } from "../../services/MembersPortalLivePerformanceValidator";
import { IUsageGroupState } from "../../../redux/types/IUsageGroupState";
import { MessageBanner, MessageType } from "../../../repertoire/components/messageBanner/MessageBanner";
import { DataSource } from "../../../repertoire/types/DataSource";
import ActionButton from "../../../repertoire/components/actionButton/ActionButton";
import { MembersPortalService } from "../../../redux/services/MembersPortalService";
import { MembersPortalRoles } from "../../../redux/types/MembersPortalRoles";
import { ITabReduxItem } from "../../../redux/types/ITabReduxItem";

export interface Step {
    title: string;
    content: any;
}

export interface ILivePerfromanceMultiStepFormProps {
    steps: Step[];
    isReadonly: boolean;
    saveChanges: () => void;
    confirmAndSubmit: () => void;
    dataSource?: string;
    current?: number;
    setCurrent?: (current: number) => void;
    usage?: IUsageGroupState;
    resetMessageBanner: () => void;
    multiStepFormViewData?: any;
    tabs?: ITabReduxItem;
    activeTab?: number;
    usageForValidation?: IUsageGroupState;
}

const LivePerformanceMultiStepForm = (props) => {
    const [errorMessages, setErrorMessages] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validatePageFields = (usage) => {
        const { multiStepFormViewData } = props;
        
        return MembersPortalLivePerformanceValidator.validateLivePerformance(usage, multiStepFormViewData);
    };

    const next = () => {
        const { current, setCurrent, usage } = props;
        if (current === 0) {
            const usageToValidate = props.usageForValidation ?? usage;
            let draftLivePerformanceValidationMessages = validatePageFields(usageToValidate);
            if (draftLivePerformanceValidationMessages.length === 0) {
                setErrorMessages([]);
                const next = current + 1;
                setCurrent(next);
            } else {
                setErrorMessages(draftLivePerformanceValidationMessages);
            }
        }

    }

    const prev = () => {
        const { current, setCurrent } = props;
        setCurrent(current - 1);
    };


    const renderErrorMessages = (messages) => {
        const { resetMessageBanner } = props;
        
        const formattedMessages = messages.map((message) =>
        typeof message === "object" && message.messageKey ? message.messageKey : message
        );
        return (
            <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Danger} messages={formattedMessages} />
        );
    };
    
    const items = props.steps.map((item) => ({ key: item.title, title: item.title }));
    const { current, dataSource, multiStepFormViewData, tabs, activeTab } = props;
    const validationErrors = !!(errorMessages.length > 0);
    const serverMessages = tabs?.[activeTab]?.validationMessages ?? [];
    const menuName = tabs[activeTab]?.name;
    const hasPermission = MembersPortalService.hasPermissionForMenu(menuName, MembersPortalRoles.FullAccess);
    
    return (
        <>
            {dataSource === DataSource.Intray ? <Steps current={current} items={items} /> : <></>}
            <div style={{ padding: '20px' }}>{props.steps[current].content}</div>
            <div className="row" style={{ marginTop: 24 }}>
                <div
                    className="btn-group form-group col-lg-4 col-lg-push-0 col-md-4 col-md-push-0 col-sm-12 col-sm-push-0 col-xs-12 col-xs-push-0"
                >
                    {current > 0 && (
                        <Button data-testid={'prev'} className="button btn-defaultSecondary" onClick={() => prev()} disabled={props.isReadonly}>
                            {multiStepFormViewData?.fields.find(f => f.name == "previous")?.data ?? "Previous"}
                        </Button>
                    )}
                </div>
                <div
                    className="btn-group form-group col-lg-4 col-lg-push-4 col-md-4 col-md-push-4 col-sm-12 col-sm-push-0 col-xs-12 col-xs-push-0"
                >
                    {current < props.steps.length - 1 && (
                        <Button data-testid={'next'} className="button btn-defaultSecondary" onClick={() => next()} >
                            {multiStepFormViewData?.fields.find(f => f.name == "next")?.data ?? "Next"}
                        </Button>
                    )}
                </div>
                {current === props.steps.length - 1 && props.dataSource === DataSource.Intray && (
                    <>
                        <div
                            className="btn-group form-group col-lg-4 col-lg-push-0 col-md-4 col-md-push-0 col-sm-12 col-sm-push-0 col-xs-12 col-xs-push-0"
                        >
                            <ActionButton buttonText= {multiStepFormViewData?.fields.find(f => f.name == "submitPerformance")?.data ?? "Submit Performance"}
                                buttonAction={ () => {
                                    setIsSubmitting(true);
                                    try {
                                        props.confirmAndSubmit();
                                    } finally {
                                        setIsSubmitting(false);
                                    }
                                }}
                                className="button btn-defaultPrimary"
                                data-testid={'confirm-submit-registration'}
                                showTooltip={!hasPermission}
                                disabled={isSubmitting || props.usage?.approvalStatus === 'Pending'}
                                /> 
                        </div>
                    </>
                )}
            </div>
            {validationErrors && renderErrorMessages(errorMessages)}
            {serverMessages.length > 0 && renderErrorMessages(serverMessages)}
        </>
    );
};

export default LivePerformanceMultiStepForm;
